import BannerAdTracker from "../BannerAdTracker/BannerAdTracker";
import GoogleTagAdapter from "../GoogleTagAdapter/GoogleTagAdapter";
import KidsMode from "../../../commons/KidsMode/KidsMode";

export default class GooglePublisherTag {
  static setPpid() {
    GoogleTagAdapter.push(function() {
      GoogleTagAdapter.setPpid();
    });
  }

  static setTargeting(props) {
    GoogleTagAdapter.push(function () {
      GoogleTagAdapter.collapseEmptyDivs();
      GoogleTagAdapter.setTargeting("Site", "VIDIO");
      GoogleTagAdapter.setTargeting("Platform", props.current_device);
      GoogleTagAdapter.setTargeting("channel", props.channel);
      GoogleTagAdapter.setTargeting("vidio_user_id", props.vidio_user_id);
      GoogleTagAdapter.setTargeting("vidio_user", props.vidio_user);
      GoogleTagAdapter.setTargeting("vidio_id", props.vidio_id);
      GoogleTagAdapter.setTargeting("vidio_categories", props.vidio_category);
      GoogleTagAdapter.setTargeting("vidio_main_genre", props.vidio_main_genre);
      GoogleTagAdapter.setTargeting("vidio_genre", props.vidio_genres && props.vidio_genres.split(",") || "");
      GoogleTagAdapter.setTargeting("vidio_country", props.vidio_country);
      GoogleTagAdapter.setTargeting("vidio_group", props.vidio_group);
      GoogleTagAdapter.setTargeting("vidio_event", props.vidio_events && props.vidio_events.split(",") || "");
      GoogleTagAdapter.setTargeting("banner_embed", props.banner_embed);
      GoogleTagAdapter.setTargeting("livestreaming_tag", props.livestreaming_tag);
      GoogleTagAdapter.setTargeting("vidio_tag", props.vidio_tag);
      GoogleTagAdapter.setTargeting("vidio_collection_id", props.vidio_collection_id);

      if (props.banner_embed === "true") {
        GoogleTagAdapter.setTargeting(
          "vidio_embed_site",
          GooglePublisherTag.embedSite()
        );
      }

      if (KidsMode.isActive()) {
        GoogleTagAdapter.setChildDirectedTreatment(true);
      }
    });
  }

  static setCompanionAds() {
    GoogleTagAdapter.companionAds().setRefreshUnfilledSlots(true);
    GoogleTagAdapter.enableVideoAds();
  }

  static shouldRefresh(element, desktop) {
    let bounding = element.getBoundingClientRect();
    let thresholdTop = 0;
    if (desktop) {
      thresholdTop =
        document.querySelector(".site-header").offsetHeight / 2 + 1;
    }

    if (
      document.visibilityState === "visible" &&
      document.fullscreenElement == null &&
      bounding.top >= thresholdTop
    ) {
      return true;
    } else {
      return false;
    }
  }

  static refreshAdSlot(slot, id, desktop = false) {
    setInterval(function () {
      var el = document.getElementById(id);
      if (GooglePublisherTag.shouldRefresh(el, desktop)) {
        GoogleTagAdapter.push(function () {
          GoogleTagAdapter.refresh([slot]);
        });
      }
    }, 60 * 1000);
  }

  static constructAdProps(adSlot, adUuid, event) {
    var props = {};
    props.ad_slot = adSlot;
    props.ad_uuid = adUuid;
    props.advertiser_id = event.advertiserId;
    props.campaign_id = event.campaignId;
    props.creative_id = event.creativeId;
    props.is_empty = event.isEmpty;
    props.line_item_id = event.lineItemId;
    props.size = event.size;
    props.source_agnostic_creative_id = event.sourceAgnosticCreativeId;
    props.source_agnostic_line_item_id = event.sourceAgnosticLineItemId;
    return props;
  }

  static setAdLeaderboard(ad_slot, ad_size) {
    GoogleTagAdapter.push(function () {
      var ad_name = "leaderboard";
      var parsed_ad_size = JSON.parse(ad_size);

      GooglePublisherTag.adjustUILeaderboard();
      GooglePublisherTag.trackSlotRenderEnded(ad_name);
      GooglePublisherTag.trackImpressionViewable(ad_name);

      window.kmklabs.gpt.leaderboard = GoogleTagAdapter.defineSlotWithCompanionAds(
        ad_slot,
        parsed_ad_size,
        ad_name
      );

      GooglePublisherTag.setCompanionAds();
      GooglePublisherTag.pushSlot(window.kmklabs.gpt.leaderboard, true);
    });
  }

  static setAdPause(ad_slot, ad_size) {
    GoogleTagAdapter.push(function () {
      var parsed_ad_size = JSON.parse(ad_size);

      GooglePublisherTag.trackSlotRenderEndedPause();
      GooglePublisherTag.trackImpressionViewablePause();

      window.kmklabs.gpt.pause_ads = GoogleTagAdapter.defineSlot(
        ad_slot,
        parsed_ad_size,
        "pause_ads"
      ).setTargeting("user_login", `${window.isUserSignedIn}`);
      GooglePublisherTag.pushSlot(window.kmklabs.gpt.pause_ads, false);
    });
  }

  static setAdOverlay(ad_slot, ad_size) {
    GoogleTagAdapter.push(function () {
      GooglePublisherTag.adjustUIOverlay();

      GooglePublisherTag.trackSlotRenderEndedOverlay();
      GooglePublisherTag.trackImpressionViewableOverlay();

      var parsed_ad_size = JSON.parse(ad_size);
      window.kmklabs.gpt.overlay_ad = GoogleTagAdapter.defineSlot(
        ad_slot,
        parsed_ad_size,
        "overlay_ad"
      );
      GooglePublisherTag.pushSlot(window.kmklabs.gpt.overlay_ad, false);
    });
  }

  static setAdTopBanner(ad_slot, ad_size) {
    GoogleTagAdapter.push(function () {
      var ad_name = "top_banner";
      var parsed_ad_size = JSON.parse(ad_size);

      GooglePublisherTag.adjustUITopBanner();
      GooglePublisherTag.trackSlotRenderEnded(ad_name);
      GooglePublisherTag.trackImpressionViewable(ad_name);

      window.kmklabs.gpt.top_banner = GoogleTagAdapter.defineSlotWithCompanionAds(
        ad_slot,
        parsed_ad_size,
        ad_name
      );

      GooglePublisherTag.setCompanionAds();
      GooglePublisherTag.pushSlot(window.kmklabs.gpt.top_banner, true);
    });
  }

  static setAdMiddleBanner(ad_slot, ad_size) {
    GoogleTagAdapter.push(function () {
      var ad_name = "middle_banner";
      var parsed_ad_size = JSON.parse(ad_size);

      GooglePublisherTag.adjustUIMiddleBanner();
      GooglePublisherTag.trackSlotRenderEnded(ad_name);
      GooglePublisherTag.trackImpressionViewable(ad_name);

      var slot = GoogleTagAdapter.defineSlot(ad_slot, parsed_ad_size, ad_name);
      GooglePublisherTag.pushSlot(slot, true);
    });
  }

  static isEventSlotType(slotName, event) {
    try {
      return !event.isEmpty && event.slot.getSlotId().getDomId() == slotName;
    } catch {
      return false;
    }
  }

  static adjustUILeaderboard() {
    GoogleTagAdapter.addEventListener("slotRenderEnded", function (event) {
      if (GooglePublisherTag.isEventSlotType("leaderboard", event)) {
        document.querySelector("#leaderboard").style.paddingTop = "18px";
      }
    });
  }

  static adjustUIOverlay() {
    GoogleTagAdapter.addEventListener("slotRenderEnded", function (event) {
      if (GooglePublisherTag.isEventSlotType("overlay_ad", event)) {
        const width = event.size[0];
        const height = event.size[1];
        window.player.ads().overlay().showOverlayAd(width, height);
      }
    });
  }

  static adjustUITopBanner() {
    GoogleTagAdapter.addEventListener("slotRenderEnded", function (event) {
      if (GooglePublisherTag.isEventSlotType("top_banner", event)) {
        document.querySelector("#top_banner").style.textAlign =
          "-webkit-center";
      }
    });
  }

  static adjustUIMiddleBanner() {
    GoogleTagAdapter.addEventListener("slotRenderEnded", function (event) {
      if (GooglePublisherTag.isEventSlotType("middle_banner", event)) {
        document
          .querySelector("#middle_banner")
          .setAttribute("style", "text-align: center; margin-top: 12px; margin-bottom: 12px;");
      }
    });
  }

  static getOffsetHeight(element) {
    return element.offsetHeight;
  }

  static trackSlotRenderEnded(ad_name) {
    GoogleTagAdapter.addEventListener("slotRenderEnded", function (event) {
      if (event.slot.getSlotId().getDomId() == ad_name) {
        var ad_uuid = BannerAdTracker.uuid();

        if (event.isEmpty) {
          BannerAdTracker.sendAdEventEmpty(ad_name, ad_uuid);
        } else {
          var props = GooglePublisherTag.constructAdProps(
            ad_name,
            ad_uuid,
            event
          );
          BannerAdTracker.sendAdEventStart(props);

          var ad_unit = event.slot.getAdUnitPath();
          GooglePublisherTag.setAdUnitUUIDandSlot(ad_unit, ad_uuid, ad_name)
        }
      }
    });
  }

  static trackImpressionViewable(ad_name) {
    GoogleTagAdapter.addEventListener("impressionViewable", function (event) {
      if (event.slot.getSlotId().getDomId() == ad_name) {
        var ad_unit = event.slot.getAdUnitPath();
        var ad_uuid = window.kmklabs.gpt.ad_unit[`${ad_unit}`];
        BannerAdTracker.sendAdEventImpressionViewable(ad_name, ad_uuid);
      }
    });
  }

  static trackSlotRenderEndedPause() {
    GoogleTagAdapter.addEventListener("slotRenderEnded", function (event) {
      if (event.slot.getSlotId().getDomId() == "pause_ads") {
        var ad_uuid = BannerAdTracker.uuid();

        var props = GooglePublisherTag.constructAdProps("pause_ads", ad_uuid, event);
        if (event.isEmpty) {
          window.player.ads().pauseAdvertisement().sendEmptyEvent(props);
        } else {
          window.player.ads().pauseAdvertisement().sendStartEvent(props);

          var ad_unit = event.slot.getAdUnitPath();
          GooglePublisherTag.setAdUnitUUIDandSlot(ad_unit, ad_uuid, "pause_ads")
        }
      }
    });
  }

  static trackImpressionViewablePause() {
    GoogleTagAdapter.addEventListener("impressionViewable", function (event) {
      if (event.slot.getSlotId().getDomId() == "pause_ads") {
        var ad_unit = event.slot.getAdUnitPath();
        var ad_uuid = window.kmklabs.gpt.ad_unit[`${ad_unit}`];
        var props = { ad_uuid: ad_uuid };
        window.player.ads().pauseAdvertisement().sendImpressionEvent(props);
      }
    });
  }

  static trackSlotRenderEndedOverlay() {
    GoogleTagAdapter.addEventListener("slotRenderEnded", function (event) {
      if (event.slot.getSlotId().getDomId() == "overlay_ad") {
        var ad_uuid = BannerAdTracker.uuid();

        var props = GooglePublisherTag.constructAdProps("overlay", ad_uuid, event);
        if (event.isEmpty) {
          window.player.ads().overlay().sendEmptyEvent(props);
        } else {
          window.player.ads().overlay().sendStartEvent(props);

          var ad_unit = event.slot.getAdUnitPath();
          GooglePublisherTag.setAdUnitUUIDandSlot(ad_unit, ad_uuid, "overlay")
        }
      }
    });
  }
  static trackImpressionViewableOverlay() {
    GoogleTagAdapter.addEventListener("impressionViewable", function (event) {
      if (event.slot.getSlotId().getDomId() == "overlay_ad") {
        var ad_unit = event.slot.getAdUnitPath();
        var ad_uuid = window.kmklabs.gpt.ad_unit[`${ad_unit}`];
        var props = { ad_uuid: ad_uuid };
        window.player.ads().overlay().sendImpressionEvent(props);
      }
    });
  }

  static setAdUnitUUIDandSlot(ad_unit, ad_uuid, ad_slot) {
    window.kmklabs.gpt.ad_unit = window.kmklabs.gpt.ad_unit || {};
    window.kmklabs.gpt.ad_unit[`${ad_unit}`] = {
      ad_uuid: ad_uuid,
      ad_slot: ad_slot,
    };
  }

  static enableLazyLoad() {
    var options = {
      fetchMarginPercent: 0,
      renderMarginPercent: 0,
      mobileScaling: 1,
    };

    GoogleTagAdapter.push(function () {
      GoogleTagAdapter.enableLazyLoad(options);
    });
  }

  static enableServices() {
    GoogleTagAdapter.push(function () {
      window.googletag.enableServices();
    });
  }

  static pushSlot(adSlot, callDisplay) {
    window.kmklabs.gpt.slots.push({slot: adSlot, callDisplay: callDisplay});
  }

  static displayAllBanners() {
    GoogleTagAdapter.push(() => {
      window.kmklabs.gpt.slots.forEach(slot => { if(slot.callDisplay) { window.googletag.display(slot.slot); } });
    });
  }

  static embedSite() {
    const hostname = this.referrer().match(
      /^(?:https?:\/\/)?(?:[^@\n]+@)?([^:\/\n]+)/im
    );
    if (hostname === null) {
      return "null";
    }
    return hostname[1];
  }

  static referrer() {
    return document.referrer;
  }
}
